import React, { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const itemStyle =
    "block lg:inline-block mt-2 lg:mt-0 text-gray-700 hover:text-gray-200 cursor-pointer";

  return (
    <nav className="bg-white p-4">
      <div className=" mx-auto flex justify-between items-center">
        {/* Logo */}
        <div
          className="m-10 mb-2 cursor-pointer min-h-[50px]"
          onClick={() => (window.location.href = "/")}
        >
          <img
            src={require("../assets/images/web_logo.png")}
            style={{ maxWidth: "30%" }}
          />
          {window.innerWidth > 800 &&
          !window.location.href?.includes(".com/new") ? (
            <p className="fs-bold fs-6 text-gray-500 mt-2">
      
              Eye Gaze and Touch Control AAC
            </p>
          ) : null}
        </div>

        {/* Menu Button (Mobile) */}
        <button
          className="lg:hidden text-gray-700 focus:outline-none"
          onClick={toggleMenu}
        >
          {isOpen ? (
            <div className="bi bi-x fs-2 mx-4"></div>
          ) : (
            <div className="bi bi-list fs-1"></div>
          )}
        </button>
        <div
          className={`${
            isOpen ? "block" : "hidden"
          } w-full lg:flex lg:items-center lg:w-auto lg:space-x-6`}
        >
            <a href="/" className={itemStyle}>
            Home
          </a>
          <a href="/#buy-now" className={itemStyle + " bg-[#6699ff] p-3 rounded text-white fw-bold"}>
            Buy Now
          </a>
          <a href="/how" className={itemStyle}>
            How It Works
          </a>
        <a href="/about" className={itemStyle}>
            About
          </a>

          <a href="/contact" className={itemStyle}>
          Contact
          </a>
          </div>
      </div>
      
    </nav>
  );
};

export default Navbar;
